import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialTipoSpazioDisponibileState } from './tipo_spazio_disponibile.state';
import { getTipoSpazioDisponibile } from './tipo_spazio_disponibile.utility';
import { GetTipoSpazioDisponibileGQL } from '../../_graphql/generated';

export const TipoSpazioDisponibileStore = signalStore(
  { providedIn: 'root' },
  withState(initialTipoSpazioDisponibileState),
  withProps(() => ({
    getter: inject(GetTipoSpazioDisponibileGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getTipoSpazioDisponibile(injector, store, getter),
  })),
);
